import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";

import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Autocomplete from "@mui/material/Autocomplete";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { autoTable } from "jspdf-autotable";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";

import { useNavigate } from "react-router-dom";

import { RABSearchParams, getRab, createRab, uploadRabPhoto, editRab, fetchRabPhotoBlob, deleteRab, RABDetailSearchParams, getRabDetail, deleteRabDetail, SCurveSearchParams, getSCurve, createRabDetail, createSCurve, deleteSCurve } from "../services/rabService.tsx";
import { fetchAhs } from "../../sales/services/ahsService.tsx";
import { fetchEmployees, getEmployees } from "../../data_management/services/employeeService.tsx";
import { getOfficeProjects } from "../services/projectDetailServices.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

const grafanaURL = process.env.REACT_APP_GRAFANA_URL || "http://localhost:3030";

// Dummy Data
const rabReviewData = [
  {
    keterangan: "Sewa Perancah",
    volume: 1,
    satuan: "Ls",
    hargaSatuan: 5000000,
    jumlahHarga: 5000000
  },
  {
    keterangan: "Pembongkaran Atap",
    volume: 30,
    satuan: "M2",
    hargaSatuan: 1000000,
    jumlahHarga: 30000000
  },
  {
    keterangan: "Pemasangan Seng",
    volume: 580,
    satuan: "LS",
    hargaSatuan: 1000000,
    jumlahHarga: 580000000
  }
];

const jumlahHarga = rabReviewData.reduce((acc, curr) => acc + curr.jumlahHarga, 0);
const ppn = Math.round(jumlahHarga * 0.11);
const totalHarga = jumlahHarga + ppn;

const sCurveData = [
  {
    category: "Pekerjaan Persiapan",
    keterangan: "Sewa Perancah",
    nilai: 5000000,
    bobot: 0.75,
    bobotMinggu: 0.04,
    durasi: "3 Weeks",
    start: "01/07/2021",
    end: "22/07/2021"
  },
  {
    category: "Pekerjaan Atap",
    keterangan: "Pembongkaran Atap",
    nilai: 10000000,
    bobot: 1,
    bobotMinggu: 0.5,
    durasi: "2 Weeks",
    start: "01/07/2021",
    end: "15/07/2021"
  },
  {
    category: "Pekerjaan Atap",
    keterangan: "Pemasangan Seng",
    nilai: 1000000,
    bobot: 90,
    bobotMinggu: 90,
    durasi: "1 Weeks",
    start: "01/08/2021",
    end: "08/08/2021"
  }
];


const projectTypeColors = {
  "PST": "green",
  "MB": "lightgreen",
  "PJTK": "#164396  ",
  "KON": "gray",
  "SK": "orange"
};

const statuses = ["Not Approved", "Approved", "Rejected"];
const projectTypes = ["Residential", "Commercial", "Infrastructure", "Industrial"];
const constructionPhases = ["Planning", "Design", "Procurement", "Execution", "Finishing"];
const pembebanan = ["SPP", "Pemberi Kerja", "Dana Pensiun"];

const RABPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddRabDialog, setOpenAddRabDialog] = useState(false);
  const [isApprover, setIsApprover] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [startDateS, setStartDateS] = useState<string | null>(null);
  const [endDateS, setEndDateS] = useState<string | null>(null);

  const [startDateE, setStartDateE] = useState<string | null>(null);
  const [endDateE, setEndDateE] = useState<string | null>(null);

  const [valueMin, setValueMin] = useState("");
  const [valueMax, setValueMax] = useState("");

  const [isEditedRabDetail, setIsEditedRabDetail] = useState(false);
  const [isEditedSCurve, setIsEditedSCurve] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);


  const [ahsOptions, setAhsOptions] = useState<any[]>([]);
  const [projectOptions, setProjectOptions] = useState<any[]>([]);
  const [employeeOptions, setEmployeeOptions] = useState<any[]>([]);


  const [totalRabAdd, setTotalRabAdd] = useState(0);
  const [totalRabEdit, setTotalRabEdit] = useState(0);

  const [bobotAdd, setBobotAdd] = useState(0);
  const [bobotEdit, setBobotEdit] = useState(0);


  const nullProject = {
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  }

  const [projectAdd, setProjectAdd] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [projectEdit, setProjectEdit] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const fetchAhsList = async () => {
    try {
      const result = await fetchAhs();
      setAhsOptions(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const fetchEmployeeList = async () => {
    try {
      const result = await fetchEmployees();
      setEmployeeOptions(result); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };

  const fetchProjectList = async () => {
    try {
      const result = await getOfficeProjects({ limit: 10000000 });
      setProjectOptions(result.data); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  function terbilang(nilai) {
    const angka = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];

    function convert(n) {
      n = Math.floor(n);
      if (n < 12) return angka[n];
      else if (n < 20) return convert(n - 10) + " Belas";
      else if (n < 100) return convert(Math.floor(n / 10)) + " Puluh " + convert(n % 10);
      else if (n < 200) return "Seratus " + convert(n - 100);
      else if (n < 1000) return convert(Math.floor(n / 100)) + " Ratus " + convert(n % 100);
      else if (n < 2000) return "Seribu " + convert(n - 1000);
      else if (n < 1000000) return convert(Math.floor(n / 1000)) + " Ribu " + convert(n % 1000);
      else if (n < 1000000000) return convert(Math.floor(n / 1000000)) + " Juta " + convert(n % 1000000);
      else if (n < 1000000000000) return convert(Math.floor(n / 1000000000)) + " Miliar " + convert(n % 1000000000);
      else return "Angka terlalu besar";
    }

    return convert(nilai).replace(/\s+/g, " ").trim();
  }


  const showPopupMandatoryError = (detail) => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: detail,
    });
  };

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "rabName", label: "Nama RAB" },
    { value: "rabNumber", label: "No RAB" },
    { value: "pembebanan", label: "Pembebanan" },
    { value: "buildingLocationId", label: "Office Project" },
    { value: "employeeNik", label: "Approver" },
    { value: "status", label: "Status" },
    // { value: "startDate", label: "Start Date" },
    // { value: "endDate", label: "End Date" },
  ];

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "rabName", label: "Nama RAB" },
    { value: "rabNumber", label: "No RAB" },
    { value: "pembebanan", label: "Pembebanan" },
    { value: "buildingLocationId", label: "Office Project" },
    { value: "employeeNik", label: "Approver" },
    { value: "status", label: "Status" },
    // { value: "startDate", label: "Start Date" },
    // { value: "endDate", label: "End Date" },
  ];

  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    rabName?: string;
    rabNumber?: string;
    pembebanan?: string;
    pemberiKerja?: string;
    buildingLocationId?: string;
    status?: string;
    employeeNik?: string;
    limit?: number;
    offset?: number;
    orderBy?: string;
    order?: string;
  }>({});

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const fetchRabs = async () => {
    setIsLoading(true);
    try {


      const result = await getRab({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });



      setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchProjectList();
    fetchEmployeeList();
    fetchAhsList();
    fetchRabs();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  const [rabData, setRabData] = useState<{
    buildingLocationId: string,
    rabName: string,
    rabNumber: string,
    pembebanan: string,
    grandTotal: string,
    ppn: string,
    diskon: string,
    file: File | null;
  }>({
    buildingLocationId: "",
    rabName: "",
    rabNumber: "",
    pembebanan: "",
    grandTotal: "0",
    ppn: "11",
    diskon: "0",
    file: null,
  });

  const [errors, setErrors] = useState({
    buildingLocationId: false,
    rabName: false,
    rabNumber: false,
    pembebanan: false,
    grandTotal: false,
    ppn: false,
    diskon: false,
  });

  const [openEditRabDialog, setOpenEditRabDialog] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [editRabData, setEditRabData] = useState<{
    id: string,
    buildingLocationId: string,
    rabName: string,
    rabNumber: string,
    pembebanan: string,
    grandTotal: string,
    ppn: string,
    diskon: string,
    employeeNik: string,
    status: string,
    position: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    buildingLocationId: "",
    rabName: "",
    rabNumber: "",
    pembebanan: "",
    grandTotal: "0",
    ppn: "11",
    diskon: "0",
    employeeNik: "",
    status: "",
    position: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [originalEditRabData, setOriginalEditRabData] = useState<{
    id: string,
    buildingLocationId: string,
    rabName: string,
    rabNumber: string,
    pembebanan: string,
    grandTotal: string,
    ppn: string,
    diskon: string,
    employeeNik: string,
    status: string,
    position: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    buildingLocationId: "",
    rabName: "",
    rabNumber: "",
    pembebanan: "",
    grandTotal: "0",
    ppn: "11",
    diskon: "0",
    employeeNik: "",
    status: "",
    position: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [editErrors, setEditErrors] = useState({
    buildingLocationId: false,
    rabName: false,
    rabNumber: false,
    pembebanan: false,
    grandTotal: false,
    ppn: false,
    diskon: false,
  });

  const nullAhs = {
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
  };

  const [ahsData, setAhsData] = useState<{
    id: string,
    namaAHS: string,
    category: string,
    volume: string,
    satuanAHS: string,
    hargaSatuan: string,
    totalAHS: string,
    totalHarga: string,
  }>({
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
  });

  const [rabDetailAdd, setRabDetailAdd] = useState<Array<{
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
  }>>([]);

  const availableAhsOptions = useMemo(() => {
    const usedAhsIds = new Set(rabDetailAdd.map((detail) => detail.ahsId));
    return ahsOptions.filter((ahs) => !usedAhsIds.has(ahs.id));
  }, [ahsOptions, rabDetailAdd]);


  const handleAddAhsToRabDetail = () => {
    if (!ahsData.id || !ahsData.volume || !ahsData.totalHarga) {
      Swal.fire({
        icon: "warning",
        title: "Data AHS belum lengkap",
        text: "Pastikan semua data AHS sudah terisi sebelum menambahkan.",
      });
      return;
    }

    const newDetail = {
      rabId: "", // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: ahsData.id,
      volume: ahsData.volume,
      totalHarga: ahsData.totalHarga.toString(),
      hargaSatuan: ahsData.totalAHS.toString(),
      satuanAHS: ahsData.satuanAHS,
      category: ahsData.category,
      namaAHS: ahsData.namaAHS,
    };

    const updatedDetails = [...rabDetailAdd, newDetail];
    setRabDetailAdd(updatedDetails);

    const ttl = Number(
      updatedDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    ).toFixed(2);
    setTotalRabAdd(Number(ttl));
    console.log("Total RAB setelah update:", ttl);

    setAhsData(nullAhs); // reset form AHS
  };

  const nullRabToSCurve = {
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  };

  const [rabToSCurveAdd, setRabToSCurveAdd] = useState<{
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>({
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  });

  const [sCurveAdd, setSCurveAdd] = useState<Array<{
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);

  const availableDetailOptions = useMemo(() => {
    const usedAhsIds = new Set(sCurveAdd.map((detail) => detail.ahsId));
    return rabDetailAdd.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
  }, [rabDetailAdd, sCurveAdd]);

  const handleAddRABToSCurve = () => {
    if (!rabToSCurveAdd.bobotMingguan || !rabToSCurveAdd.durasiMinggu || !rabToSCurveAdd.startDate || !rabToSCurveAdd.endDate) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua data sudah terisi sebelum menambahkan ke S-Curves.",
      });
      return;
    }

    const newDetail = {
      rabId: "", // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: rabToSCurveAdd.ahsId,
      rabDetailId: "",
      nilaiPekerjaan: rabToSCurveAdd.nilaiPekerjaan,
      bobot: rabToSCurveAdd.bobot,
      durasiMinggu: rabToSCurveAdd.durasiMinggu,
      bobotMingguan: rabToSCurveAdd.bobotMingguan,
      startDate: rabToSCurveAdd.startDate,
      endDate: rabToSCurveAdd.endDate,
      namaAHS: rabToSCurveAdd.namaAHS,
      category: rabToSCurveAdd.category,
    };

    setSCurveAdd([...sCurveAdd, newDetail]);
    setRabToSCurveAdd(nullRabToSCurve); // reset form RAB
  };


  const [editAhsData, setEditAhsData] = useState<{
    id: string,
    namaAHS: string,
    category: string,
    volume: string,
    satuanAHS: string,
    hargaSatuan: string,
    totalAHS: string,
    totalHarga: string,
  }>({
    id: "",
    namaAHS: "",
    category: "",
    volume: "",
    satuanAHS: "",
    hargaSatuan: "",
    totalAHS: "",
    totalHarga: "",
  });

  const [rabDetailAddOnEdit, setRabDetailAddOnEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
  }>>([]);

  const [rabDetailOriginalEdit, setRabDetailOriginalEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    volume: string;
    totalHarga: string;
    hargaSatuan: string;
    satuanAHS: string;
    category: string;
    namaAHS: string;
  }>>([]);


  const availableAhsOptionsOnEdit = useMemo(() => {
    const usedAhsIds = new Set(rabDetailAddOnEdit.map((detail) => detail.ahsId));
    return ahsOptions.filter((ahs) => !usedAhsIds.has(ahs.id));
  }, [ahsOptions, rabDetailAddOnEdit]);

  const handleAddAhsToRabDetailOnEdit = () => {
    if (!editAhsData.id || !editAhsData.volume || !editAhsData.totalHarga) {
      Swal.fire({
        icon: "warning",
        title: "Data AHS belum lengkap",
        text: "Pastikan semua data AHS sudah terisi sebelum menambahkan.",
      });
      return;
    }

    const newDetail = {
      id: "",
      rabId: editRabData.id, // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: editAhsData.id,
      volume: editAhsData.volume,
      totalHarga: editAhsData.totalHarga.toString(),
      hargaSatuan: editAhsData.totalAHS.toString(),
      satuanAHS: editAhsData.satuanAHS,
      category: editAhsData.category,
      namaAHS: editAhsData.namaAHS,
    };

    const updatedDetails = [...rabDetailAddOnEdit, newDetail];
    const ttl = Number(
      updatedDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    ).toFixed(2);
    setTotalRabEdit(Number(ttl));
    setIsEditedRabDetail(true);
    setRabDetailAddOnEdit(updatedDetails);
    setEditAhsData(nullAhs); // reset form AHS
  };

  const nullRabToSCurveOnEdit = {
    id: "",
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  }

  const [rabToSCurveAddOnEdit, setRabToSCurveAddOnEdit] = useState<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>({
    id: "",
    rabId: "",
    ahsId: "",
    rabDetailId: "",
    nilaiPekerjaan: "",
    bobot: "",
    durasiMinggu: "",
    bobotMingguan: "",
    startDate: "",
    endDate: "",
    namaAHS: "",
    category: "",
  });

  const [sCurveAddOnEdit, setSCurveAddOnEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);

  const [sCurveOriginalEdit, setSCurveOriginalEdit] = useState<Array<{
    id: string;
    rabId: string;
    ahsId: string;
    rabDetailId: string;
    nilaiPekerjaan: string;
    bobot: string;
    durasiMinggu: string;
    bobotMingguan: string;
    startDate: string;
    endDate: string;
    namaAHS: string;
    category: string;
  }>>([]);


  const availableDetailOptionsOnEdit = useMemo(() => {
    const usedAhsIds = new Set(sCurveAddOnEdit.map((detail) => detail.ahsId));
    return rabDetailAddOnEdit.filter((ahs) => !usedAhsIds.has(ahs.ahsId));
  }, [rabDetailAddOnEdit, sCurveAddOnEdit]);

  const handleAddRABToSCurveOnEdit = () => {
    if (!rabToSCurveAddOnEdit.bobotMingguan || !rabToSCurveAddOnEdit.durasiMinggu || !rabToSCurveAddOnEdit.startDate || !rabToSCurveAddOnEdit.endDate) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua data sudah terisi sebelum menambahkan ke S-Curves.",
      });
      return;
    }

    const newDetail = {
      id: "",
      rabId: editRabData.id, // Nanti diisi saat simpan ke backend jika diperlukan
      ahsId: rabToSCurveAddOnEdit.ahsId,
      rabDetailId: "",
      nilaiPekerjaan: rabToSCurveAddOnEdit.nilaiPekerjaan,
      bobot: rabToSCurveAddOnEdit.bobot,
      durasiMinggu: rabToSCurveAddOnEdit.durasiMinggu,
      bobotMingguan: rabToSCurveAddOnEdit.bobotMingguan,
      startDate: rabToSCurveAddOnEdit.startDate,
      endDate: rabToSCurveAddOnEdit.endDate,
      namaAHS: rabToSCurveAddOnEdit.namaAHS,
      category: rabToSCurveAddOnEdit.category,
    };

    setSCurveAddOnEdit([...sCurveAddOnEdit, newDetail]);
    setIsEditedSCurve(true);
    setRabToSCurveAddOnEdit({ id: "", ...nullRabToSCurve }); // reset form RAB
  };


  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (file: File) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setRabData({ ...rabData, file });
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEditRabData({ ...editRabData, file });
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRabData({ ...rabData, [name]: value });
  };

  const handleProjectChange = (e) => {
    if (e.target.value == '') {
      setProjectAdd(nullProject);
    } else {
      const selectedProject = projectOptions.find(proj => proj.id == e.target.value);
      setProjectAdd(selectedProject);
    }
    setRabData({ ...rabData, buildingLocationId: e.target.value });
  };

  const handleAhsChange = (e) => {
    if (e.target.value == '') {
      setAhsData(nullAhs);
    } else {
      const selectedAhs = ahsOptions.find(ahs => ahs.id == e.target.value);
      setAhsData(selectedAhs);
    }

    // setRabData({ ...rabData, buildingLocationId: e.target.value });
  };

  const handleDetailChange = (e) => {
    if (e.target.value == '') {
      setRabToSCurveAdd(nullRabToSCurve);
    } else {
      const selectedRabDetail = rabDetailAdd.find(detail => detail.ahsId == e.target.value);
      const bobot = (selectedRabDetail?.totalHarga / totalRabAdd);
      setRabToSCurveAdd({ ...selectedRabDetail, nilaiPekerjaan: selectedRabDetail?.totalHarga, bobot: bobot.toString() });
    }

    // setRabData({ ...rabData, buildingLocationId: e.target.value });
  };

  const handleSCurveInputChange = (e) => {
    const { name, value } = e.target;
    setRabToSCurveAdd({ ...rabToSCurveAdd, [name]: value });
  };

  const handleInputChangeOnEdit = (e) => {
    const { name, value } = e.target;
    setEditRabData({ ...editRabData, [name]: value });
  };

  const handleProjectChangeOnEdit = (e) => {
    if (e.target.value == '') {
      setProjectEdit(nullProject);
    } else {
      const selectedProject = projectOptions.find(proj => proj.id == e.target.value);
      setProjectEdit(selectedProject);
    }
    setEditRabData({ ...editRabData, buildingLocationId: e.target.value });
  };

  const handleAhsChangeOnEdit = (e) => {
    if (e.target.value == '') {
      setEditAhsData(nullAhs);
    } else {
      const selectedAhs = ahsOptions.find(ahs => ahs.id == e.target.value);
      setEditAhsData(selectedAhs);
    }

    // setRabData({ ...rabData, buildingLocationId: e.target.value });
  };

  const handleDetailChangeOnEdit = (e) => {
    if (e.target.value == '') {
      setRabToSCurveAddOnEdit(nullRabToSCurveOnEdit);
    } else {
      const selectedRabDetail = rabDetailAddOnEdit.find(detail => detail.ahsId == e.target.value);

      const bobot = (selectedRabDetail?.totalHarga / totalRabEdit);
      setRabToSCurveAddOnEdit({ ...selectedRabDetail, nilaiPekerjaan: selectedRabDetail?.totalHarga, bobot: bobot.toString() });
    }

    // setRabData({ ...rabData, buildingLocationId: e.target.value });
  };

  const handleSCurveInputChangeOnEdit = (e) => {
    const { name, value } = e.target;
    setRabToSCurveAddOnEdit({ ...rabToSCurveAddOnEdit, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {
      buildingLocationId: !rabData.buildingLocationId,
      rabName: !rabData.rabName,
      // grandTotal: !rabData.grandTotal,
      grandTotal: false,
    };

    console.log(newErrors)

    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const validateEditForm = () => {
    let newErrors = {
      buildingLocationId: !editRabData.buildingLocationId,
      rabName: !editRabData.rabName,
      // grandTotal: !editRabData.grandTotal,
      grandTotal: false,
    };

    setEditErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const errorResponse = (title, error) => {
    let errorTitle = "";
    let errorDetails = "";

    // Handle backend error response
    if (error.response?.data) {
      const backendError = error.response.data;

      // Debug log untuk melihat struktur error
      console.log(
        "Backend Error Structure:",
        JSON.stringify(backendError, null, 2)
      );

      // Main error message
      errorTitle = backendError.error || errorTitle;

      // Handle all possible email validation error formats - PERBAIKAN UTAMA
      const isEmailValidationError =
        // Case 1: Error in details (Sequelize style)
        (backendError.details &&
          /validation isEmail on (email|projectEmail)/i.test(
            backendError.details
          )) ||
        // Case 2: Error in errors array (Sequelize validation errors)
        (backendError.errors &&
          backendError.errors.some(
            (err: any) =>
              (err.path === "email" || err.path === "projectEmail") &&
              err.validatorKey === "isEmail"
          )) ||
        // Case 3: Error in message (generic API responses)
        (backendError.message &&
          /email.*invalid/i.test(backendError.message));

      if (isEmailValidationError) {
        errorTitle = "Format Email Tidak Valid";
        errorDetails =
          "• Format email tidak valid (contoh: nama@perusahaan.com)";
      }
      // Only use details if not an email error
      else if (backendError.details) {
        errorDetails = backendError.details;
      }

      // Handle validation errors (improved processing)
      if (backendError.errors) {
        const validationMessages = backendError.errors
          .map((err: any) => {
            // Handle both array and object error formats
            const errorObj = Array.isArray(err) ? err[0] : err;

            // Skip email errors since we already handled them
            if (
              (errorObj.path === "email" ||
                errorObj.path === "projectEmail") &&
              errorObj.validatorKey === "isEmail"
            ) {
              return null;
            }
            return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
          })
          .filter(Boolean) // Remove null entries
          .join("\n");

        if (validationMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }
      }

      // Handle duplicate fields (improved formatting)
      if (backendError.duplicates) {
        const duplicateMessages = backendError.duplicates
          .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
          .join("\n");

        if (duplicateMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
    }
    // Handle network or other errors
    else {
      errorDetails =
        error.message || "Terjadi kesalahan jaringan atau server";
    }

    // Show error in Swal (improved formatting)
    Swal.fire({
      icon: "error",
      title: title,
      html: `
                <div style="text-align: left;">
                  <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
                    ${errorTitle}
                  </p>
                  ${errorDetails
          ? `<div style="
                          color: #5f2120;
                          background: #fdecea;
                          padding: 12px;
                          border-radius: 4px;
                          font-size: 0.9em;
                          border-left: 4px solid #d32f2f;
                          line-height: 1.5;
                        ">
                          ${errorDetails.replace(/\n/g, "<br>")}
                        </div>`
          : ""
        }
                </div>
              `,
      confirmButtonColor: "#0F62FE",
      width: "600px",
    });
  }


  const handleSubmitAddRab = async () => {

    if (!validateForm()) {
      return showPopupMandatoryError("Lengkapi data yang wajib diisi.");
    }

    try {
      console.log(rabData);

      const rabSumTotal = { ...rabData, grandTotal: Math.round(totalRabAdd * 1.11) }

      // Step 1: Create RAB
      const newRab = await createRab(rabSumTotal);

      if (!newRab?.id) throw new Error("Gagal membuat RAB");

      const updatedRabDetails = rabDetailAdd.map((detail) => ({
        ...detail,
        rabId: newRab.id,
      }));

      const failedDetails: string[] = [];
      const failedSCurves: string[] = [];

      // Step 2: Loop create RabDetail dan SCurve
      for (const detail of updatedRabDetails) {
        try {
          const newRabDetail = await createRabDetail(detail);

          if (!newRabDetail?.id) throw new Error("Gagal simpan detail");


        } catch (err) {
          console.error("Gagal menyimpan RAB Detail:", detail, err);
          failedDetails.push(detail.namaAHS);
        }
      }

      // Show error jika ada yang gagal
      if (failedDetails.length || failedSCurves.length) {
        const errorText = [
          failedDetails.length && `RAB Detail gagal: ${failedDetails.join(", ")}`
        ]
          .filter(Boolean)
          .join("<br>");

        await Swal.fire({
          icon: "error",
          title: "Sebagian data gagal disimpan",
          html: errorText,
        });
      } else {
        // Show success jika semua berhasil
        await Swal.fire({
          icon: "success",
          title: "RAB berhasil ditambahkan",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenAddRabDialog(false);
      setTotalRabAdd(0);
      setRabDetailAdd([]);
      setSCurveAdd([]);
      setRabData({
        buildingLocationId: "",
        rabName: "",
        rabNumber: "",
        pembebanan: "",
        grandTotal: "0",
        ppn: "11",
        diskon: "0",
        file: null,
      });
      await fetchRabs();
    } catch (error: any) {
      await errorResponse("Gagal membuat RAB", error);
    }
  };

  const handleSubmitEditRab = async () => {

    if (!validateEditForm()) {
      return showPopupMandatoryError("Lengkapi data yang wajib diisi.");
    }

    try {
      console.log(editRabData);
      const rabSumTotal = { ...editRabData, grandTotal: Math.round(totalRabEdit * 1.11) }

      // Step 1: Create RAB
      const newRab = await editRab(rabSumTotal);


      if (!newRab?.id) throw new Error("Gagal mengupdate RAB");
      console.log("editRAB", newRab);

      const failedDetails: string[] = [];

      if (isEditedRabDetail || isEditedSCurve) {
        await rabDetailOriginalEdit.map(async (detail) => (await deleteRabDetail(detail.id)));

        const updatedRabDetails = await rabDetailAddOnEdit.map((detail) => ({
          ...detail,
          rabId: newRab.id,
          id: undefined,
        }));

        // Step 2: Loop create RabDetail dan SCurve
        for (const detail of updatedRabDetails) {
          try {
            const newRabDetail = await createRabDetail(detail);

            if (!newRabDetail?.id) throw new Error("Gagal simpan detail");


          } catch (err) {
            console.error("Gagal menyimpan RAB Detail:", detail, err);
            failedDetails.push(detail.namaAHS);
          }
        }
      }


      // Show error jika ada yang gagal
      if (failedDetails.length) {
        const errorText = [
          failedDetails.length && `RAB Detail gagal: ${failedDetails.join(", ")}`,
        ]
          .filter(Boolean)
          .join("<br>");

        await Swal.fire({
          icon: "error",
          title: "Sebagian data gagal disimpan",
          html: errorText,
        });
      } else {
        // Show success jika semua berhasil
        await Swal.fire({
          icon: "success",
          title: "RAB berhasil Disimpan",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenEditRabDialog(false);
      setTotalRabEdit(0);
      setRabDetailAddOnEdit([]);
      setSCurveAddOnEdit([]);
      setEditRabData({
        id: "",
        buildingLocationId: "",
        rabName: "",
        rabNumber: "",
        pembebanan: "",
        grandTotal: "0",
        ppn: "11",
        diskon: "0",
        employeeNik: "",
        status: "",
        position: "",
        file: null,
        salesProjectImage: "",
        previewUrl: "",
      });
      setIsEditedRabDetail(false);
      setIsEditedSCurve(false);
      await fetchRabs();
    } catch (error: any) {
      await errorResponse("Gagal mengupdate RAB", error);
    }
  };

  const handleOpenEditRab = async (rab) => {

    const userJobTitle = employeeOptions.find(emp => emp.email === localStorage.getItem("email"))?.jobTitle || "";
    const isManager = (userJobTitle.toLowerCase().includes("manager") || (localStorage.getItem("username") == 'superadmin'));

    setIsApprover(isManager);


    const rabDetail = await getRabDetail({ limit: 1000000, buildingRabId: rab.id });
    const rabDetailWithAHS = rabDetail.data.map(rab => {
      // const ahsDetail = ahsOptions.find((ahs) => ahs.id === rab.ahsId);
      const ahsDetail = rab.ahs;
      rab.category = ahsDetail.category;
      rab.hargaSatuan = ahsDetail.totalAHS;
      rab.satuanAHS = ahsDetail.satuanAHS;
      rab.namaAHS = ahsDetail.namaAHS;
      return rab;
    })

    await console.log(rabDetailWithAHS);
    await setProjectEdit(rab.project);

    await setRabDetailAddOnEdit(rabDetailWithAHS);

    setIsEditedRabDetail(false);
    setIsEditedSCurve(false);

    const position = employeeOptions.find(emp => emp.nik === rab.employeeNik)?.jobTitle;

    await setEditRabData({
      ...rab,
      file: null,
      position: position,
    });
    await console.log(rab, position, editRabData);

    // Hitung ulang total setelah penghapusan
    const newTotal = Number(
      rabDetailWithAHS.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    ).toFixed(2);
    setTotalRabEdit(Number(newTotal));
    await setOriginalEditRabData(rab); // Simpan nilai asli untuk tombol cancel
    await setRabDetailOriginalEdit(rabDetailWithAHS);
    await setIsEditing(false); // Kunci form sampai tombol edit diklik
    await setOpenEditRabDialog(true);

  };

  const handleDeleteRabDetailRow = (indexToRemove: number) => {
    const ahsIdToRemove = rabDetailAdd[indexToRemove].ahsId;

    // Hapus baris dari rabDetailAdd
    const updatedRabDetails = rabDetailAdd.filter((_, idx) => idx !== indexToRemove);
    setRabDetailAdd(updatedRabDetails);

    // Hitung ulang total setelah penghapusan
    const newTotal = Number(
      updatedRabDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    ).toFixed(2);
    setTotalRabAdd(Number(newTotal));

    // setIsEditedRabDetail(true);
  };

  const handleDeleteRabDetailEdit = (indexToRemove: number) => {
    const ahsIdToRemove = rabDetailAddOnEdit[indexToRemove].ahsId;

    // Hapus baris dari rabDetailAdd
    const updatedRabDetails = rabDetailAddOnEdit.filter((_, idx) => idx !== indexToRemove);
    setRabDetailAddOnEdit(updatedRabDetails);

    // Hitung ulang total setelah penghapusan
    const newTotal = Number(
      updatedRabDetails.reduce((acc, curr) => acc + Number(curr.totalHarga), 0)
    ).toFixed(2);
    setTotalRabEdit(Number(newTotal));
    setIsEditedRabDetail(true);
  };


  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => {
        const deletedRab = await deleteRab(id);

      }));

      Swal.fire({
        icon: "success",
        title: "Rab berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchRabs(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleCancelEditRab = () => {
    setEditRabData(originalEditRabData); // Kembalikan nilai asli
    setIsEditing(false); // Kunci kembali form
    setOpenEditRabDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "id", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
    const name = filters[index].field;
    if (name === "startDate") { setStartDateS(null); setEndDateS(null); }
    if (name === "endDate") { setStartDateE(null); setEndDateE(null); }
    if (name === "valueEstimation") { setValueMin(""); setValueMax(""); }
    console.log(filters, startDateS, endDateS)
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `RABSearchParams`
      const searchParams: RABSearchParams = {};

      if (startDateS && endDateS) {
        if (startDateS === endDateS) {
          searchParams.startDate = await startDateS;
        } else {
          searchParams.startDateS = await startDateS;
          searchParams.endDateS = await endDateS;
        }
      }

      if (startDateS && !endDateS) {
        searchParams.startDate = await startDateS;
      }

      if (startDateE && endDateE) {
        if (startDateE === endDateE) {
          searchParams.endDate = await startDateE;
        } else {
          searchParams.startDateE = await startDateE;
          searchParams.endDateE = await endDateE;
        }
      }

      if (startDateE && !endDateE) {
        searchParams.endDate = await startDateE;
      }

      if (valueMin && valueMax) {
        if (valueMin === valueMax) {
          searchParams.valueEstimation = await valueMin;
        } else {
          searchParams.valueMin = await valueMin;
          searchParams.valueMax = await valueMax;
        }
      }

      if (valueMin && !valueMax) {
        searchParams.valueEstimation = await valueMin;
      }

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getRab(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
    setStartDateS(null);
    setEndDateS(null);
    setStartDateE(null);
    setEndDateE(null);
    setValueMin("");
    setValueMax("");
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getRab({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Rab");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Rabs_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export rab data',
      });
    }
  };

  const getTimeRangeFromScurve = (scurveAddOnEdit: any[]) => {
    if (!scurveAddOnEdit.length) return { from: "", to: "" };

    const startDates = scurveAddOnEdit.map((item) => new Date(item.startDate));
    const endDates = scurveAddOnEdit.map((item) => new Date(item.endDate));

    const earliestStart = new Date(Math.min(...startDates.map(d => d.getTime())));
    const latestEnd = new Date(Math.max(...endDates.map(d => d.getTime())));

    return {
      from: earliestStart.getTime().toString(),
      to: latestEnd.getTime().toString(),
    };
  };

  const [ifFrom, setIfFrom] = useState("");
  const [ifTo, setIfTo] = useState("");




  const getExportData = async () => {
    const allRabs = await getRab({
      ...filterParams,
      limit: 10000000,
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allRabs.data.map((rab, index) => ({
      'No': index + 1,
      'RAB Name': rab.rabName,
      'No RAB': rab.rabNumber,
      'Region': rab.officeProject?.office?.region || '',
      'RAB Value': Number(rab.grandTotal),
      'Location': rab.officeProject?.office?.officeAddress || '',
      'Start Date': rab.officeProject?.startDate || '',
      'End Date': rab.officeProject?.endDate || '',
    }));
  };


  const exportRabDetailToPDF = async () => {
    try {
      const doc = new jsPDF();

      // 1. Add header image
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", -10, 0, 230, 40);
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      // Add horizontal line after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 37, 200, 37);

      // 2. Main content
      const startY = 60;

      // Main title
      doc.setFontSize(18);

      const titleText = `RAB: ${editRabData.rabName || "-"}`;
      const wrappedTitle = doc.splitTextToSize(titleText, 170);
      doc.text(wrappedTitle, 105, startY - 15, { align: "center" });

      // ===== PROJECT INFORMATION TABLE =====
      doc.setFontSize(12);
      // doc.text("Project Information", 15, startY + 2);

      const project = projectOptions.find(pro => pro.id === editRabData.buildingLocationId) || {};
      const employee = employeeOptions.find(emp => emp.nik === editRabData.employeeNik) || {};

      // Header Info (No RAB, Lokasi, Pembebanan)
      doc.setFontSize(10);
      doc.text(`No RAB : ${editRabData.rabNumber || "-"}`, 15, startY + 10);
      doc.text(`Lokasi Gedung : ${project.office.officeName || "-"}`, 15, startY + 16);
      doc.text(`Pembebanan : ${editRabData.pembebanan || "-"}`, 15, startY + 22);



      // ===== RAB DETAILS TABLE =====
      const rabDetailsTitleY = startY + 30;

      // Start autoTable right after the title
      const tableStartY = rabDetailsTitleY + 5;

      doc.setFontSize(12);
      doc.text("RAB Details", 15, rabDetailsTitleY);

      autoTable(doc, {
        head: [
          [
            "No",
            "Category",
            "Description",
            "Volume",
            "Unit",
            "Unit Price",
            "Total Price",
          ],
        ],
        body: rabDetailAddOnEdit.map((item, i) => [
          `${i + 1}`,
          item.category || "-",
          item.namaAHS || "-",
          item.volume || "-",
          item.satuanAHS || "-",
          { content: `RP ${Math.round(Number(item.hargaSatuan)).toLocaleString("id-ID")}` || "-", styles: { halign: "right" } },
          { content: `RP ${Math.round(Number(item.totalHarga)).toLocaleString("id-ID")}` || "-", styles: { halign: "right" } },
        ]),
        foot: [
          [
            {
              content: "Jumlah",
              colSpan: 6,
              styles: { halign: "right", fontStyle: "bold" },
            },
            {
              content: `RP ${totalRabEdit.toLocaleString("id-ID", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
              styles: { halign: "right", fontStyle: "bold" },
            },
          ],
          [
            {
              content: `Diskon ${editRabData.diskon ? editRabData.diskon : ""}%`,
              colSpan: 6,
              styles: { halign: "right" },
            },
            {
              content: `RP ${(totalRabEdit * (Number(editRabData.diskon) / 100)).toLocaleString("id-ID", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
              styles: { halign: "right" },
            },
          ],
          [
            {
              content: `Harga Setelah Diskon ${editRabData.diskon ? editRabData.diskon : ""}%`,
              colSpan: 6,
              styles: { halign: "right" },
            },
            {
              content: `RP ${(totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)).toLocaleString("id-ID", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
              styles: { halign: "right" },
            },
          ],
          [
            {
              content: `PPN ${editRabData.ppn ? editRabData.ppn : ""}%`,
              colSpan: 6,
              styles: { halign: "right" },
            },
            {
              content: `RP ${((totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) * (Number(editRabData.ppn) / 100)).toLocaleString("id-ID", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
              styles: { halign: "right" },
            },
          ],
          [
            {
              content: "Total",
              colSpan: 6,
              styles: { halign: "right", fontStyle: "bold" },
            },
            {
              content: `RP ${(
                (totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) +
                (totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) * (Number(editRabData.ppn) / 100)
              ).toLocaleString("id-ID", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`,
              styles: { halign: "right", fontStyle: "bold" },
            },
          ],
        ],

        footStyles: {
          fillColor: [230, 230, 230],
          fontSize: 8,
          textColor: [0, 0, 0],
          halign: "right",
        },
        startY: tableStartY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: {
          cellPadding: 2,
          fontSize: 8,
        },
        columnStyles: {
          4: { cellWidth: "auto", minCellHeight: 10 },
        },
      });

      // ===== SUMMARY SECTION =====
      const summaryStartY = (doc as any).lastAutoTable.finalY + 10;

      // Calculate column positions
      const labelCol = 130;  // Right-aligned labels
      const valueCol = 180;  // Right-aligned values

      // Amount in words
      doc.setFontSize(9);
      const amountText = `Terbilang: ${terbilang(Math.round(totalRabEdit * 1.11))} Rupiah`;
      doc.text(amountText, 15, summaryStartY, { maxWidth: 180 });


      // Approver Footer Section
      const footerStartY = summaryStartY + 12;
      const formattedDate = new Date().toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      doc.text(`Jakarta, ${formattedDate}`, 15, footerStartY + 10);
      doc.text(`\n\n${employee.name || "-"}\n${employee.jobTitle || "-"}`, 15, footerStartY + 20);


      // Footer
      // doc.setFontSize(8);
      // doc.setTextColor(100);
      // doc.text("Generated by RAB System", 105, 285, { align: "center" });
      // doc.text(new Date().toLocaleString(), 105, 290, { align: "center" });

      // 3. Save PDF
      const date = new Date().toISOString().slice(0, 10);
      doc.save(`RAB_${editRabData.rabName || "new"}_${date}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const exportRabDetailToExcel = async () => {
    try {
      // Prepare data for Excel export
      const project = projectOptions.find(pro => pro.id === editRabData.buildingLocationId) || {};
      console.log(project);

      // 1. Create workbook
      const wb = XLSX.utils.book_new();

      // 2. Create Project Information sheet
      const projectInfoData = [
        ["RAB Name", editRabData.rabName || "-"],
        ["RAB Value", `Rp ${Number(editRabData.grandTotal || 0).toLocaleString("id-ID")}` || "-"],
        ["Office Name", project.office.officeName || "-"],
        ["Building Value", `Rp ${Number(project.buildingValuation || 0).toLocaleString("id-ID")}`],
        ["Office Address", project.office.officeAddress || "-"],
        ["Pembebanan", editRabData.pembebanan || "-"],
      ];

      const projectInfoWs = XLSX.utils.aoa_to_sheet([
        ["PROJECT INFORMATION"],
        [], // empty row
        ...projectInfoData
      ]);

      // 3. Create RAB Details sheet
      const rabDetailsHeader = [
        "No",
        "Category",
        "Description",
        "Volume",
        "Unit",
        "Unit Price",
        "Total Price"
      ];

      const rabDetailsData = rabDetailAddOnEdit.map((item, index) => [
        index + 1,
        item.category || "-",
        item.namaAHS || "-",
        Math.round(Number(item.volume)) || "-",
        item.satuanAHS || "-",
        `${(Number(item.hargaSatuan))}`,
        `${(Number(item.totalHarga))}`
      ]);

      // Hitungan seperti PDF
      const subtotal = totalRabEdit;
      const diskonPersen = Number(editRabData.diskon) || 0;
      const ppnPersen = Number(editRabData.ppn) || 0;

      const diskonNominal = (subtotal * (diskonPersen / 100));
      const setelahDiskon = (subtotal - diskonNominal);
      const ppnNominal = (setelahDiskon * (ppnPersen / 100));
      const total = Math.round(setelahDiskon + ppnNominal); // dibulatkan

      const rabDetailsWs = XLSX.utils.aoa_to_sheet([
        ["RAB DETAILS"],
        [],
        rabDetailsHeader,
        ...rabDetailsData,
        [],
        [],
        [
          "", "", "", "", "",
          "Jumlah",
          // `${subtotal.toLocaleString("id-ID", {
          //   minimumFractionDigits: 2,
          //   maximumFractionDigits: 2
          // })}`
          Number(subtotal)
        ],
        [
          "", "", "", "", "",
          `Diskon ${diskonPersen}%`,
          // `${(diskonNominal).toLocaleString("id-ID", {
          //   minimumFractionDigits: 2,
          //   maximumFractionDigits: 2
          // })}`
          Number(diskonNominal)
        ],
        [
          "", "", "", "", "",
          `Harga Setelah Diskon ${diskonPersen}%`,
          // `${setelahDiskon.toLocaleString("id-ID", {
          //   minimumFractionDigits: 2,
          //   maximumFractionDigits: 2
          // })}`
          Number(setelahDiskon)
        ],
        [
          "", "", "", "", "",
          `PPN ${ppnPersen}%`,
          // `${ppnNominal.toLocaleString("id-ID", {
          //   minimumFractionDigits: 2,
          //   maximumFractionDigits: 2
          // })}`
          Number(ppnNominal)
        ],
        [
          "", "", "", "", "",
          "Total",
          // `${total.toLocaleString("id-ID")}` // tanpa desimal
          Math.round(Number(total))
        ],
        [],
        ["Amount in words:", terbilang(total) + " Rupiah"]
      ]);

      // Lebar kolom
      rabDetailsWs["!cols"] = [
        { wch: 5 },  // No
        { wch: 25 }, // Category
        { wch: 35 }, // Description
        { wch: 10 }, // Volume
        { wch: 10 }, // Unit
        { wch: 25 }, // Label footer
        { wch: 20 }  // Nominal
      ];


      // Merge title cells
      projectInfoWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } } // Merge PROJECT INFORMATION title
      ];

      rabDetailsWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // Merge RAB DETAILS title
        { s: { r: rabDetailsData.length + 3, c: 0 }, e: { r: rabDetailsData.length + 3, c: 6 } }, // Merge amount in words
        { s: { r: rabDetailsData.length + 4, c: 0 }, e: { r: rabDetailsData.length + 4, c: 6 } } // Merge amount in words value
      ];

      // 5. Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, projectInfoWs, "Project Info");
      XLSX.utils.book_append_sheet(wb, rabDetailsWs, "RAB Details");

      // 6. Generate and download Excel file
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `RAB_Details_${editRabData.rabName || "export"}_${date}.xlsx`);

    } catch (error) {
      console.error("Error exporting to Excel:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate Excel file",
      });
    }
  };

  return (
    isLoading ? <LoadingOverlay /> :
      <Box sx={{ padding: 3 }}>
        {/* Header & Tabs */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            RAB List
          </Typography>
        </Box>

        {/* Toolbar */}
        <Box className="toolbar">
          {/* Left Controls */}
          <Box className="leftControls">
            <Typography>Show</Typography>
            <Select value={rowsPerPage} onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }} size="small">
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>

            {/* Search Button & Input */}
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={() => setShowSearch((prev) => !prev)}
              className="searchButton"
            >
              Search
            </Button>
            {showSearch && (
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchQuery}
                onChange={async (e) => {
                  await setSearchQuery(e.target.value);
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
                autoFocus
                className="searchInput"
              />
            )}

            {/* Menampilkan Error */}
            {error && <p style={{ color: "red" }}>{error}</p>}
          </Box>

          {/* Right Controls */}
          <Box className="rightControls">
            <Button
              startIcon={<Delete />}
              variant="text"
              onClick={() => {
                const selectedData = rows.filter((row) => selectedRows.includes(row.rabid));
                setItemsToDelete(selectedData);
                setOpenDeleteDialog(true);
              }}
              disabled={selectedRows.length === 0}
            >
              Delete
            </Button>
            {/* Filter Button */}
            <Button
              startIcon={<FilterList />}
              variant="text"
              onClick={() => setOpenFilterDialog(true)}
            >
              Filters
            </Button>
            {/* <Button startIcon={<Download />} variant="contained" className="exportButton" onClick={() => handleExport()}>
              Export
            </Button> */}
            <Button startIcon={<Add />} variant="contained" className="addItemDetailsButton" onClick={() => { setOpenAddRabDialog(true) }}>
              Add New Rab
            </Button>
          </Box>
        </Box>


        {/* Delete Button & Subtitle */}

        <Box className="deleteContainer">
          <Typography variant="body2" className="detailsSubtitle">
            Details List Of All RAB
          </Typography>
        </Box>


        {/* Table */}
        <TableContainer component={Paper} className="tableContainer">
          <Table className="table">
            <TableHead className="tableHead">
              <TableRow>
                {/* Checkbox header */}
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                    checked={selectedRows.length === rows.length}
                    onChange={() =>
                      setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                    }
                  />
                </TableCell>
                <TableCell>No</TableCell>
                {/* Header dengan sorting */}
                <TableCell className="tableCell" onClick={() => handleSort("rabName")} style={{ cursor: "pointer" }}>
                  <strong>RAB Name</strong>
                  {sortConfig.orderBy === "rabName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("rabNumber")} style={{ cursor: "pointer" }}>
                  <strong>No RAB</strong>
                  {sortConfig.orderBy === "rabNumber" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("officeProject.officeName")} style={{ cursor: "pointer" }}>
                  <strong>Nama Project</strong>
                  {sortConfig.orderBy === "officeProject.officeName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("officeProject.office.region")} style={{ cursor: "pointer" }}>
                  <strong>Region</strong>
                  {sortConfig.orderBy === "officeProject.office.region" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("grandTotal")} style={{ cursor: "pointer" }}>
                  <strong>RAB Value</strong>
                  {sortConfig.orderBy === "grandTotal" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("officeProject.office.officeAddress")} style={{ cursor: "pointer" }}>
                  <strong>Location</strong>
                  {sortConfig.orderBy === "officeProject.office.officeAddress" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("startDate")} style={{ cursor: "pointer" }}>
                  <strong>Start Date</strong>
                  {sortConfig.orderBy === "startDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("endDate")} style={{ cursor: "pointer" }}>
                  <strong>End Date</strong>
                  {sortConfig.orderBy === "endDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell">
                </TableCell> {/* Kolom untuk aksi */}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  {/* Checkbox */}
                  <TableCell padding="checkbox" className="tableCell">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  {/* Data */}
                  <TableCell className="tableCell" title={row.rabName}><strong>{row.rabName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.rabNumber}><strong>{row.rabNumber}</strong></TableCell>
                  <TableCell className="tableCell" title={row.officeProject?.office.officeName}><strong>{row.officeProject?.office.officeName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.officeProject?.office.region}><strong>{row.officeProject?.office.region}</strong></TableCell>
                  <TableCell className="tableCell" title={row.grandTotal}><strong>{`Rp ${Number(row.grandTotal).toLocaleString("id-ID")}`}</strong></TableCell>
                  <TableCell className="tableCell" title={row.officeProject?.office.officeAddress}><strong>{row.officeProject?.office.officeAddress}</strong></TableCell>
                  <TableCell className="tableCell" title={row.officeProject?.startDate}>{row.officeProject?.startDate}</TableCell>
                  <TableCell className="tableCell" title={row.officeProject?.endDate}>{row.officeProject?.endDate}</TableCell>
                  {/* Ikon More Options */}
                  <TableCell className="tableCell">
                    <IconButton onClick={() => { setTotalRabEdit(0); handleOpenEditRab(row) }}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>


        {/* Pagination */}
        <Box
          className="paginationContainer"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "16px 0",
          }}
        >
          {/* Info jumlah data */}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`Showing ${offset + 1} to ${Math.min(
              offset + rowsPerPage,
              totalItems
            )} of ${totalItems} entries`}
          </Typography>

          {/* Komponen Pagination */}
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, page) => setCurrentPage(page)}
            className="pagination"
            showFirstButton
            showLastButton
            renderItem={(item) => (
              <PaginationItem
                {...item}
                components={{ first: FirstPage, last: LastPage }}
              />
            )}
          />
        </Box>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
          <DialogTitle>Delete Rows?</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
            <Button onClick={handleDeleteRows} color="error">Delete</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Add New Rab */}
        <Dialog open={openAddRabDialog} onClose={() => setOpenAddRabDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Add New Rab</Typography>
              <IconButton onClick={() => setOpenAddRabDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth label="RAB Name" name="rabName" margin="normal"
                placeholder="RAB Name" value={rabData.rabName}
                onChange={handleInputChange}
                error={!rabData.rabName}
                helperText={!rabData.rabName ? "Mandatory Field" : ""}
              />
              <TextField
                fullWidth label="RAB Number" name="rabNumber" margin="normal"
                placeholder="RAB Number" value={rabData.rabNumber}
                onChange={handleInputChange}
                error={!rabData.rabNumber}
                helperText={!rabData.rabNumber ? "Mandatory Field" : ""}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Autocomplete
                fullWidth
                options={projectOptions}
                getOptionLabel={(option) => option.office.officeName || ""}
                value={projectOptions.find(opt => opt.id === rabData.buildingLocationId) || null}
                onChange={(event, newValue) => {
                  handleProjectChange({
                    target: {
                      name: "buildingLocationId",
                      value: newValue ? newValue.id : ""
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Project Name" name="projectName"
                    placeholder="Enter project name"
                    fullWidth
                    error={!rabData.buildingLocationId}
                    helperText={!rabData.buildingLocationId ? "Mandatory Field" : ""}
                  />
                )}
              />
              <TextField
                select
                fullWidth
                label="Pembebanan"
                placeholder="Pembebanan"
                value={rabData.pembebanan}
                onChange={(e) => setRabData({ ...rabData, pembebanan: e.target.value })}
                error={!rabData.pembebanan}
                helperText={!rabData.pembebanan ? "Mandatory Field" : ""}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="SPP">SPP</MenuItem>
                <MenuItem value="Pemberi Kerja">Pemberi Kerja</MenuItem>
                <MenuItem value="Dana Pensiun">Dana Pensiun</MenuItem>
              </TextField>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                type="number"
                fullWidth label="PPN" name="ppn" margin="normal"
                placeholder="PPN" value={rabData.ppn}
                onChange={handleInputChange}
                error={!rabData.ppn}
                helperText={!rabData.ppn ? "Mandatory Field" : ""}
              />
              <TextField
                type="number"
                fullWidth label="Diskon" name="diskon" margin="normal"
                placeholder="Diskon" value={rabData.diskon}
                onChange={handleInputChange}
                error={!rabData.diskon}
                helperText={!rabData.diskon ? "Mandatory Field" : ""}
              />
            </Box>


            {/* AHS */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Input AHS</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>

                <Autocomplete
                  fullWidth
                  options={availableAhsOptions}
                  getOptionLabel={(option) => option.namaAHS || ""}
                  value={
                    ahsData?.id
                      ? availableAhsOptions.find((opt) => opt.id === ahsData.id) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleAhsChange({
                      target: {
                        name: "id",
                        value: newValue ? newValue.id : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="AHS Name"
                      name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth
                      error={!ahsData.id}
                      helperText={!ahsData.id ? "Mandatory Field" : ""}
                    />
                  )}
                />

                <TextField
                  fullWidth label="AHS Category" name="ahsCategory"
                  placeholder="Enter AHS Category" value={ahsData.category}
                  disabled
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Satuan AHS" name="satuanAHS"
                  placeholder="Enter satuan AHS" value={ahsData.satuanAHS}
                  disabled
                />

                <TextField
                  fullWidth label="Harga Satuan (Rp)" name="hargaSatuan"
                  placeholder="Enter harga satuan AHS" value={ahsData.totalAHS}
                  disabled
                />

                <TextField
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={ahsData.volume}
                  onChange={(e) => setAhsData({ ...ahsData, volume: e.target.value, totalHarga: (Number(ahsData.totalAHS) * Number(e.target.value)) })}
                  error={!ahsData.volume}
                  helperText={!ahsData.volume ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={ahsData.totalHarga}
                  disabled
                />
              </Box>

              <Button
                variant="outlined"
                color="primary"
                sx={{ width: 180 }}
                onClick={handleAddAhsToRabDetail}
              >
                Tambahkan ke RAB Detail
              </Button>



            </Box>

            {/* Section A - RAB Review */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. RAB Review</Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Keterangan</TableCell>
                    <TableCell>Volume</TableCell>
                    <TableCell>Satuan</TableCell>
                    <TableCell>Harga Satuan</TableCell>
                    <TableCell>Jumlah Harga</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rabDetailAdd.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => {
                            handleDeleteRabDetailRow(index);
                            // setRabDetailAdd((prev) => prev.filter((_, i) => i !== index));
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.namaAHS}</TableCell>
                      <TableCell>{row.volume}</TableCell>
                      <TableCell>{row.satuanAHS}</TableCell>
                      <TableCell>{`RP ${Number(row.hargaSatuan || 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</TableCell>
                      <TableCell>{`RP ${Number(row.totalHarga || 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</TableCell>
                    </TableRow>
                  ))}
                  {/* Hitungan Akhir */}
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Jumlah</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`RP ${(totalRabAdd).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">Diskon {rabData.diskon ? rabData.diskon : ''}%</TableCell>
                    <TableCell>
                      {`RP ${(totalRabAdd * (Number(rabData.diskon) / 100)).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">Harga Setelah Diskon {rabData.diskon ? rabData.diskon : ''}%</TableCell>
                    <TableCell>
                      {`RP ${(totalRabAdd - totalRabAdd * (Number(rabData.diskon) / 100)).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">PPN {rabData.ppn ? rabData.ppn : ''}%</TableCell>
                    <TableCell>
                      {`RP ${((totalRabAdd - totalRabAdd * (Number(rabData.diskon) / 100)) * (Number(rabData.ppn) / 100)).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Total</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`RP ${Math.round((totalRabAdd - totalRabAdd * (Number(rabData.diskon) / 100)) + (totalRabAdd - totalRabAdd * (Number(rabData.diskon) / 100)) * (Number(editRabData.ppn) / 100)).toLocaleString("id-ID")}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Terbilang: {terbilang(Math.round((totalRabAdd - totalRabAdd * (Number(rabData.diskon) / 100)) + (totalRabAdd - totalRabAdd * (Number(rabData.diskon) / 100)) * (Number(editRabData.ppn) / 100)))} Rupiah
              </Typography>

            </Box>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddRabDialog(false)}>CANCEL</Button>
            <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddRab}>SAVE</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Edit RAB */}
        <Dialog open={openEditRabDialog} onClose={() => setOpenEditRabDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">RAB</Typography>
              <IconButton onClick={() => setOpenEditRabDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                disabled={!isEditing}
                fullWidth label="RAB Name" name="rabName" margin="normal"
                placeholder="RAB Name" value={editRabData.rabName}
                onChange={handleInputChangeOnEdit}
                error={!editRabData.rabName}
                helperText={!editRabData.rabName ? "Mandatory Field" : ""}
              />
              <TextField
                disabled={!isEditing}
                fullWidth label="RAB Number" name="rabNumber" margin="normal"
                placeholder="RAB Number" value={editRabData.rabNumber}
                onChange={handleInputChangeOnEdit}
                error={!editRabData.rabNumber}
                helperText={!editRabData.rabNumber ? "Mandatory Field" : ""}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Autocomplete
                fullWidth
                disabled={!isEditing}
                options={projectOptions}
                getOptionLabel={(option) => option.office.officeName || ""}
                value={projectOptions.find(opt => opt.id === editRabData.buildingLocationId) || null}
                onChange={(event, newValue) => {
                  handleProjectChangeOnEdit({
                    target: {
                      name: "buildingLocationId",
                      value: newValue ? newValue.id : ""
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Project Name" name="projectName"
                    placeholder="Enter project name"
                    fullWidth
                    error={!editRabData.buildingLocationId}
                    helperText={!editRabData.buildingLocationId ? "Mandatory Field" : ""}
                  />
                )}
              />
              <TextField
                select
                fullWidth
                disabled={!isEditing}
                label="Pembebanan"
                placeholder="Pembebanan"
                value={editRabData.pembebanan}
                onChange={(e) => setEditRabData({ ...editRabData, pembebanan: e.target.value })}
                error={!editRabData.pembebanan}
                helperText={!editRabData.pembebanan ? "Mandatory Field" : ""}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="SPP">SPP</MenuItem>
                <MenuItem value="Pemberi Kerja">Pemberi Kerja</MenuItem>
                <MenuItem value="Dana Pensiun">Dana Pensiun</MenuItem>
              </TextField>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                type="number"
                disabled={!isEditing}
                fullWidth label="PPN" name="ppn" margin="normal"
                placeholder="PPN" value={editRabData.ppn}
                onChange={handleInputChangeOnEdit}
                error={!editRabData.ppn}
                helperText={!editRabData.ppn ? "Mandatory Field" : ""}
              />
              <TextField
                type="number"
                disabled={!isEditing}
                fullWidth label="Diskon" name="diskon" margin="normal"
                placeholder="Diskon" value={editRabData.diskon}
                onChange={handleInputChangeOnEdit}
                error={!editRabData.diskon}
                helperText={!editRabData.diskon ? "Mandatory Field" : ""}
              />
            </Box>

            {/* AHS */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: isEditing ? "flex" : "none", flexDirection: "column", gap: 2, mt: 2 }} hidden={!isEditing}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Input AHS</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Autocomplete
                  disabled={!isEditing}
                  fullWidth
                  options={availableAhsOptionsOnEdit}
                  getOptionLabel={(option) => option.namaAHS || ""}
                  value={
                    editAhsData?.id
                      ? availableAhsOptionsOnEdit.find((opt) => opt.id === editAhsData.id) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleAhsChangeOnEdit({
                      target: {
                        name: "id",
                        value: newValue ? newValue.id : ""
                      }
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="AHS Name" name="namaAHS"
                      placeholder="Enter ahs name"
                      fullWidth error={!editAhsData.id}
                      helperText={!editAhsData.id ? "Mandatory Field" : ""}
                    />
                  )}
                />
                <TextField
                  fullWidth label="AHS Category" name="ahsCategory"
                  placeholder="Enter AHS Category" value={editAhsData.category}
                  disabled
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  fullWidth label="Satuan AHS" name="satuanAHS"
                  placeholder="Enter satuan AHS" value={editAhsData.satuanAHS}
                  disabled
                />

                <TextField
                  fullWidth label="Harga Satuan (Rp)" name="hargaSatuan"
                  placeholder="Enter harga satuan AHS" value={editAhsData.totalAHS}
                  disabled
                />

                <TextField
                  disabled={!isEditing}
                  fullWidth label="Volume" name="volume"
                  placeholder="Enter Volume" value={editAhsData.volume}
                  onChange={(e) => setEditAhsData({ ...editAhsData, volume: e.target.value, totalHarga: (Number(editAhsData.totalAHS) * Number(e.target.value)) })}
                  error={!editAhsData.volume}
                  helperText={!editAhsData.volume ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Jumlah Harga (Rp)" name="totalHargaAHS"
                  placeholder="Enter jumlah harga satuan AHS" value={editAhsData.totalHarga}
                  disabled
                />
              </Box>

              <Button
                disabled={!isEditing}
                variant="outlined"
                color="primary"
                sx={{ width: 180 }}
                onClick={handleAddAhsToRabDetailOnEdit}
              >
                Tambahkan ke RAB Detail
              </Button>



            </Box>

            {/* Section A - RAB Review */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. RAB Review</Typography>
              <Box textAlign={"right"} sx={{ mb: 2 }}>
                <Button
                  onClick={exportRabDetailToPDF}
                  variant="outlined"
                  startIcon={<PictureAsPdf />}
                  color="error"
                >
                  Export PDF
                </Button>
                <Button
                  onClick={exportRabDetailToExcel}
                  variant="outlined"
                  startIcon={<Download />}
                  color="success"
                  sx={{ ml: 1 }}
                >
                  Export Excel
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Keterangan</TableCell>
                    <TableCell>Volume</TableCell>
                    <TableCell>Satuan</TableCell>
                    <TableCell>Harga Satuan</TableCell>
                    <TableCell>Jumlah Harga</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rabDetailAddOnEdit.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => {
                            if (isEditing) {
                              handleDeleteRabDetailEdit(index);
                              // setRabDetailAddOnEdit((prev) => prev.filter((_, i) => i !== index));
                              // deleteRabDetail(row.id);
                            }
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.namaAHS}</TableCell>
                      <TableCell>{row.volume}</TableCell>
                      <TableCell>{row.satuanAHS}</TableCell>
                      <TableCell>{`RP ${Number(row.hargaSatuan || 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</TableCell>
                      <TableCell>{`RP ${Number(row.totalHarga || 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</TableCell>
                    </TableRow>
                  ))}
                  {/* Hitungan Akhir */}
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Jumlah</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`RP ${(totalRabEdit).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">Diskon {editRabData.diskon ? editRabData.diskon : ''}%</TableCell>
                    <TableCell>
                      {`RP ${(totalRabEdit * (Number(editRabData.diskon) / 100)).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">Harga Setelah Diskon {editRabData.diskon ? editRabData.diskon : ''}%</TableCell>
                    <TableCell>
                      {`RP ${(totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right">PPN {editRabData.ppn ? editRabData.ppn : ''}%</TableCell>
                    <TableCell>
                      {`RP ${((totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) * (Number(editRabData.ppn) / 100)).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={7} align="right"><strong>Total</strong></TableCell>
                    <TableCell>
                      <strong>
                        {`RP ${Math.round((totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) + (totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) * (Number(editRabData.ppn) / 100)).toLocaleString("id-ID")}`}
                      </strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Terbilang: {terbilang(Math.round((totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) + (totalRabEdit - totalRabEdit * (Number(editRabData.diskon) / 100)) * (Number(editRabData.ppn) / 100)))} Rupiah
              </Typography>

            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Approval RAB</Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  select
                  fullWidth
                  disabled={!isEditing || !isApprover}
                  label="Status Approval"
                  placeholder="Status Approval"
                  value={editRabData.status}
                  onChange={(e) => setEditRabData({ ...editRabData, status: e.target.value })}
                // error={!editRabData.status}
                // helperText={!editRabData.status ? "Mandatory Field" : ""}
                >
                  {/* <MenuItem value="">Select</MenuItem> */}
                  {statuses.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <Autocomplete
                  fullWidth
                  disabled={!isEditing || !isApprover}
                  options={employeeOptions}
                  getOptionLabel={(option) => option.name || ""}
                  value={employeeOptions.find(opt => opt.nik === editRabData.employeeNik) || null}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    setEditRabData((prev) => ({
                      ...prev,
                      employeeNik: newValue?.nik || "",
                      position: newValue?.jobTitle || "",
                    }));
                    console.log(editRabData)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Employee Name" name="name"
                      placeholder="Employee name"
                      fullWidth
                    />
                  )}
                />
                <TextField
                  fullWidth
                  disabled
                  label="Posisi"
                  placeholder="Posisi"
                  value={editRabData.position || ''}
                />
              </Box>

            </Box>



          </DialogContent>


          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            {!isEditing ? (
              // Tombol Edit Muncul di Awal
              <Button onClick={() => setIsEditing(true)} variant="contained" color="primary" sx={{ width: 120 }}>
                EDIT
              </Button>
            ) : (
              // Tombol Save & Cancel Muncul Saat Edit
              <>
                <Button onClick={() => setIsEditing(false)} variant="outlined" color="error" sx={{ width: 120 }}>
                  CANCEL
                </Button>
                <Button onClick={handleSubmitEditRab} variant="contained" color="success" sx={{ width: 120 }}>
                  SAVE
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>




        {/* ======================= Filter Dialog ============================= */}
        <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
          <DialogTitle>Advanced Search</DialogTitle>
          <DialogContent>
            {filters.map((filter, index) => {
              const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
              const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));

              return (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                  <TextField
                    select
                    value={filter.field}
                    onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {availableOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  {filter.field === "buildingLocationId" ? (
                    <TextField
                      select
                      label="Office Project"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {projectOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.office.officeName}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "approver" ? (
                    <TextField
                      select
                      label="Approver"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {employeeOptions.map((option) => (
                        <MenuItem key={option.id} value={option.nik}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "pembebanan" ? (
                    <TextField
                      select
                      label="Pembebanan"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {pembebanan.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "status" ? (
                    <TextField
                      select
                      label="Status"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {statuses.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "startDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateS ? dayjs(startDateS) : null}
                          onChange={(newValue) =>
                            setStartDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateS ? dayjs(endDateS) : null}
                          onChange={(newValue) =>
                            setEndDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "endDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateE ? dayjs(startDateE) : null}
                          onChange={(newValue) =>
                            setStartDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateE ? dayjs(endDateE) : null}
                          onChange={(newValue) =>
                            setEndDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "valueEstimation" ? (
                    <>
                      <TextField
                        label="Value Min"
                        variant="outlined"
                        size="small"
                        value={valueMin}
                        onChange={(e) =>
                          setValueMin(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                      <TextField
                        label="Value Max"
                        variant="outlined"
                        size="small"
                        value={valueMax}
                        onChange={(e) =>
                          setValueMax(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    </>

                  ) : (
                    <TextField
                      label="Value"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                  )}

                  {index > 0 && (
                    <IconButton onClick={() => handleRemoveFilter(index)}>
                      <Remove />
                    </IconButton>
                  )}
                </Box>
              );
            })}

            {filters.length < availableFilters.length && (
              <Button startIcon={<Add />} onClick={handleAddFilter}>
                Add Filter
              </Button>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleResetFilters}>Reset Filter</Button>
            <Button onClick={handleCloseFilter}>Cancel</Button>
            <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
              {isLoading ? "Loading..." : "Apply"}
            </Button>
          </DialogActions>
        </Dialog>

      </Box>
  );
};

export default RABPage;
